import type { ActivityItem } from '../activity-journal';
import { activityIdentitiesEqual } from '../activity-journal';
import type { ActivityBuildingResolutionRequest } from './building-resolver';

export function activityBuildingIds(
    items: readonly ActivityItem[]
): readonly string[] {
    return [
        ...new Set([
            ...items.flatMap((item) =>
                item.jobs.flatMap((job) =>
                    job.buildingPublicId ? [job.buildingPublicId] : []
                )
            ),
        ]),
    ].sort((left, right) => left.localeCompare(right));
}

export function enrichmentRequestsEqual(
    left: ActivityBuildingResolutionRequest,
    right: ActivityBuildingResolutionRequest
): boolean {
    return (
        activityIdentitiesEqual(left.identity, right.identity) &&
        left.activeIdentityVersion === right.activeIdentityVersion &&
        left.buildingPublicIds.length === right.buildingPublicIds.length &&
        left.buildingPublicIds.every(
            (buildingPublicId, index) =>
                buildingPublicId === right.buildingPublicIds[index]
        )
    );
}
